import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  getHolidayList,
  getReimbursementCategories,
} from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DeleteConfirmationModel } from "utils/helperComponent";
import { toastMessage } from "utils/toastMessage";

const messageStyle = {
  width: "50%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const Main = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [addEdit, setAddEdit] = useState("Add");
  const [editId, seteditId] = useState("");

  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);

  const [schemeErr, setschemeErr] = useState({
    category: false,
    subCategory: false,
  });

  const Validate = () => {
    let value = true;
    let err = {};

    if (category === "" || category === " ") {
      err.category = "Please Enter Category Name.";
      value = false;
    }

    if (subCategory.length === 0) {
      err.subCategory = "Please Enter Sub Category";
      value = false;
    }
    setschemeErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const categoryData = await getReimbursementCategories();
    setData(categoryData?.data);
    setMessage(categoryData?.message);
    setLoading(true);
    setTotalPages(categoryData?.totalPage ?? 1);
  }, [message]);

  const handelSubmit = async () => {
    if (!Validate()) return;
    let data = {
      categoryName: category,
      subCategory,
    };
    let url =
      addEdit === "Add"
        ? `/api/v1/admin/reimbursement/category`
        : `/api/v1/admin/reimbursement/category/${editId}`;
    const response = await authAxios()({
      url: url,
      method: addEdit === "Add" ? "POST" : "PUT",
      data,
    });
    console.log("repsonse", response?.data);
    setMessage(response?.data?.message);
    setOpenModal(false);
    toastMessage(response?.data?.message, "success");
  };

  const confirmDelete = async (id) => {
    console.log("idd", id);
    const response = await authAxios()({
      url: `/api/v1/holiday/${id}`,
      method: "DELETE",
    });
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };

  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleKeyPress = (e) => {
    const allowedCharacters = /^[a-zA-Z\s]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleSelectedItemsChange = (event, newValue) => {
    setSubCategory(newValue);
  };

  const handleAddItem = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      setSubCategory((prevItems) => [...prevItems, event.target.value]);
      event.target.value = "";
    }
  };

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Reimbursement Categories
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "1rem",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            setAddEdit("Add");
            setOpenModal(true);
          }}
        >
          Add Category
        </Button>
      </div>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    S No.
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Category
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Sub Categories
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Last Updated
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d, idx) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{idx + 1}</TableCell>
                      <TableCell align="center">{d?.categoryName}</TableCell>
                      <TableCell align="center">
                        {d?.subCategory?.map((t) => t.subCategory).join(", ")}
                      </TableCell>
                      <TableCell align="center">
                        {moment.utc(d?.updatedAt).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="center">
                        <EditIcon
                          sx={{
                            cursor: "pointer",
                            color: "green",
                          }}
                          onClick={() => {
                            setCategory(d?.categoryName);
                            setSubCategory(
                              d?.subCategory.map((item) => item.subCategory)
                            );
                            setAddEdit("Edit");
                            seteditId(d?._id);
                            setOpenModal(true);
                          }}
                        />
                        {/* <DeleteIcon
                          sx={{
                            cursor: "pointer",
                            color: "red",
                          }}
                          onClick={() => handleDelete(d?._id)}
                        /> */}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box sx={{ textAlign: "left", pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>
                      No Holiday List Avilable.
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>
            <Grid justifyContent={"center"} container p={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Grid>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      {isDeleteDialogOpen ? (
        <DeleteConfirmationModel
          onOpen={isDeleteDialogOpen}
          onClose={handleCloseDialog}
          confirmDelete={confirmDelete}
          deletedItemId={deletedItemId}
        />
      ) : null}

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setSubCategory([]);
          setCategory("");
          seteditId("");
          setschemeErr({
            category: false,
            subCategory: false,
          });
        }}
      >
        <Box sx={messageStyle}>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", textDecoration: "underline" }}
          >
            {addEdit} Category
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Category Name</Typography>
              <TextField
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                sx={{ width: "50%" }}
                name="category"
                label="Category"
                variant="outlined"
                onKeyPress={handleKeyPress}
                error={schemeErr.category}
                helperText={schemeErr.category}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Sub Category</Typography>
              <Autocomplete
                multiple
                value={subCategory}
                sx={{ width: "50%", marginTop: "20px" }}
                onChange={handleSelectedItemsChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Enter Subcategory"
                    placeholder="Enter Subcategory"
                    // onKeyPress={handleKeyPress}
                    onKeyDown={handleAddItem}
                    error={schemeErr.subCategory}
                    helperText={schemeErr.subCategory}
                  />
                )}
                // renderTags={renderTags}
                options={[]}
                freeSolo
              />
            </div>
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* After Entering a Sub Category, press ENTER from the keyboard`}
            </Typography>
            <Box sx={{ m: 2, display: "flex", justifyContent: "space-evenly" }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setschemeErr({
                    category: false,
                    subCategory: false,
                  });
                  setSubCategory([]);
                  setCategory("");
                  seteditId("");
                  setOpenModal(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={() => handelSubmit()}>
                Submit
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>
    </>
  );
};

const ReimbursementCategory = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default ReimbursementCategory;
